// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4z-0";
export var startPickingButton = "_4z-1";